import CopyrightFooter from "./CopyrightFooter";
import ScrollToTop from "../../common/ScrollTop";
import React from "react";

const index = ({ footerStyle = "" }) => {
  return (
    <footer className={`main-footer ${footerStyle}`}>
      <div className="auto-container">
        {/* <!--Widgets Section--> */}
        <div className="widgets-section" data-aos="fade-up">
          <div className="row mb-3">
            <div className="big-column col-xl-3 col-lg-3 col-md-12">
              <div className="footer-column about-widget mb-2">
                <div className="logo" style={{marginBottom : "15px"}}>
                  <a href="https://groupe.talents-handicap.com" target="_blank" rel="noopener noreferrer">
                    <img
                      width={200}
                      src="/images/Logo-THF-web.png"
                      alt="brand"
                    />
                  </a>
                </div>
              </div>
            </div>
            {/* End footer left widget */}

            <div className="big-column col-xl-6 col-lg-6 col-md-12" style={{fontSize : "13px"}}>
                Groupe <b>Talents Handicap</b>, pionnier depuis 2012 dans le recrutement et la formation pour l'emploi des personnes en situation de handicap.
            </div>
              {/*<div className="big-column col-xl-3 col-lg-3 col-md-12">
                  <div className="social-links">
                      <Social/>
                  </div>
              </div>*/}
              {/* End col-xl-8 */}
          </div>
        </div>
      </div>
      {/* End auto-container */}

      <CopyrightFooter/>
      <ScrollToTop/>
      {/* <!--Bottom--> */}
    </footer>
    //   {/* <!-- End Main Footer --> */}
  );
};

export default index;
